import { sanitizeHtmlContent } from '@utils/sanitizeHtml.util'

/**
 * Converts HTML (e.g. rich note body) to a single-line plain string for tooltips and previews.
 * Sanitizes first, then reads text from an inert template.
 */
export function htmlToPlainTextPreview(
  html: string | null | undefined,
): string {
  if (html == null || html.trim() === '') {
    return ''
  }
  const htmlWithLineBreaks = sanitizeHtmlContent(html)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|tr|h[1-6])>/gi, '\n')

  const template = document.createElement('template')
  template.innerHTML = htmlWithLineBreaks
  let text = template.content.textContent ?? ''
  text = text
    .replace(/\r/g, '')
    .replace(/\n+/g, ' ')
    .replace(/\u00A0/g, ' ')
    .trim()
  return text.replace(/[ \t]+/g, ' ')
}
